import { rootRoutesFor } from '@porotutu/react'
import type { Home } from '@porotutu/react/components/StatusPage/StatusPage'
import { Layout } from '../components/Layout'
import { sessionConfig } from '../session'

export const HOME: Home = { to: '/organizations', labelKey: 'pages.home_link.adm' }

export const { rootRoute, signedInRoute, permittedRoute } = rootRoutesFor({
  session: sessionConfig,
  layout: Layout,
})

export type { RouterContext } from '@porotutu/react'
